export default __webpack_public_path__ + "static/media/incorrect_cross.38c733ef.svg";